import { BlockRenderer, BlockRendererProps } from 'app/features/shared/blocks'
import { getOfferBlockMappings } from './block-mappings'

export const OfferBlockRenderer = (props: BlockRendererProps) => {
  return <BlockRenderer {...props} additionalComponents={getOfferBlockMappings()} />
}
